// 跟消息相关的接口
import request from '../../request'
import download from '../../download'
export function fetchList(params) {
    return request({
        url: '/office-service/oa/purchase_materials/category/list',
        params,
    })
}

export function add(data) {
    return request({
        url: '/office-service/oa/purchase_materials/category/add',
        data,
        method: "post",
    })
}
export function edit(data) {
    return request({
        url: '/office-service/oa/purchase_materials/category/update',
        data,
        method: "post",
    })
}
export function deleteCategory(id) {
    return request({
        url: '/office-service/oa/purchase_materials/category/del/' + id,
        method: "delete",
    })
}
export function addStorage(data) {
    return request({
        url: '/office-service/giftWarehouseEntry/add',
        data,
        method: "post",
    })
}



// 调整库存
export function adjust(data) {
    return request({
        url: '/office-service/oa/purchase_materials/adjust',
        data,
        method: "post",
    })
}

// 申请物料
export function apply(data) {
    return request({
        url: '/office-service/oa/purchase_materials/add',
        data,
        method: "post"
    })
}

// 申领台账
export function fetchApplyList(year) {
    return request({
        url: '/office-service/oa/purchase_materials/month/get/' + year,
    })
}
export function fetchWareList(params) {
    return request({
        url: '/office-service/giftWarehouseEntry/list',
        params,
    })
}
export function fetchWareDetail(id) {
    return request({
        url: '/office-service/giftWarehouseEntry/detail/' + id,
    })
}
export function fetchApplyDeptList(data) {
    return request({
        url: '/office-service/oa/purchase_materialsApply/standingBookDept',
        data,
        method: 'post'
    })
}

export function fetchApplyDetail(data) {
    return request({
        url: `/office-service/oa/purchase_materials/${data.id}`,
    })
}

export function reapply(data) {
    return request({
        url: '/office-service/oa/purchase_materials/update',
        data,
        method: 'post'
    })
}

export function downloadFile(data) {
    return download({
        url: '/office-service/oa/purchase_materials/goods/export/' + data,
    })
}
export function downloadDepartmentListFile(data) {
    return download({
        url: '/office-service/oa/purchase_materials/export/' + data,
    })
}


export function fetchDepartmentList(year, deptName) {
    return request({
        url: '/office-service/oa/purchase_materials/goods/get/' + year + '/' + deptName,
    })
}

// 办公室外部采购申请列表
export function fetchOfficeList(params) {
    return request({
        url: '/office-service/oa/purchase_materials_office/list',
        params,
    })
}

// 新增办公室外部采购申请
export function addOfficeApply(data) {
    return request({
        url: '/office-service/oa/purchase_materials_office/add',
        data,
        method: 'post',
    })
}

// 办公室外部采购申请详情查询
export function fetchOfficeDetail(id) {
    return request({
        url: '/office-service/oa/purchase_materials_office/detail/' + id,
    })
}

// 重新发起办公室外部采购申请
export function resubmitOfficeApply(data) {
    return request({
        url: '/office-service/oa/purchase_materials_office/resubmit',
        data,
        method: 'post',
    })
}

// 按类别查询品名规格
export function fetchNamesSpecs(category) {
    return request({
        url: '/office-service/oa/purchase_materials/namesSpecs/' + category,
    })
}